import { ApplicationState } from '@/redux/stores/types'

import { IAction } from '../actions/action-helpers'
import { PackagesUsagesTypes } from '../actions/actions.types'

type PackagesUsagesState = ApplicationState['packagesUsages']

function packagesUsagesReducer(state: PackagesUsagesState = [], action: IAction): PackagesUsagesState {
	switch (action.type) {
		case PackagesUsagesTypes.GetUsageDetails.SUCCESS:
			return action.payload
	}
	return state
}

export default packagesUsagesReducer
